document.addEventListener("DOMContentLoaded", function() {
        // 
    try{
        let menuImgs = document.querySelectorAll('a.mega-menu__promo-link.media-wrapper img');

        if (menuImgs) {
            menuImgs.forEach(function (e) {
            e.setAttribute('alt', '');
            })
        }
    } catch(e){}

    // 
    try{
        let productcart = document.querySelectorAll('.product-grid .card-information');
        if (productcart.length > 0) {
            let i = 1;
            productcart.forEach(function (e) {
                let cartLink = e.querySelector('a.custom-cartlink');
                let cartBtn = e.querySelector('.button.custom-cartlink');
                
                if (cartLink) {
                    cartLink.setAttribute('id', 'cart' + i);
                    cartLink.addEventListener('focus', function (e) {
                        let allCartBtns = document.querySelectorAll('.button.custom-cartlink');
                        if (allCartBtns) {
                            allCartBtns.forEach(function (otherCartBtn) {
                              otherCartBtn.style.opacity = '0';
                            })
                        }
                    })
                }
                
                if (cartBtn && cartLink) {
                    let btn = cartBtn.querySelector('button');
                    if (btn) {
                        btn.setAttribute('aria-labelledby', 'cart' + i);
                    }
                    cartLink.addEventListener('focus', function (e) {
                        cartBtn.style.opacity = '1';
                        cartBtn.style.transform = 'translateY(0)';
                    })
                }
    
                i += 1;
            });
        }
    
        let hoverproducts = document.querySelectorAll('.card-wrapper');
        if (hoverproducts) {
            hoverproducts.forEach(function (e) {
                e.addEventListener('mouseover', function () {
                    let hoverprod = e.querySelector('.card-information__button .button');
                    if (hoverprod) {
                        hoverprod.style.opacity = '1';
                    }
                });
    
                e.addEventListener('mouseout', function () {
                    let hoverprod = e.querySelector('.card-information__button .button');
                    if (hoverprod) {
                        hoverprod.style.opacity = '0';
                    }
                });
            });
        }
    } catch(e){}

    // 
    try{
        let calform = document.querySelector('shipping-calculator form-state');

        if (calform) {
            let element = document.createElement('div');
            let textElement = document.createTextNode("All fields are required");
            element.style.textAlign = 'center';
            element.appendChild(textElement);
            calform.parentNode.insertBefore(element, calform);
        }
    } catch(e){}

    // 
    try{
        let searchLabel = document.querySelectorAll('form.search.search-modal__form > div > button.search__button.focus-inset[type="submit"]');

        if (searchLabel) {
            searchLabel.forEach(function (e) {
                e.ariaLabel = "Search";
            })
        }
    } catch(e){}

    // 
    try{
        let cartLink = document.querySelector('.cart-drawer-container .header__icon.focus-inset');

        if (cartLink) {
            function cartfocus() {
                let focusElement = document.querySelector('mini-cart#mini-cart');
                if (focusElement) {
                    focusElement.addEventListener('focus', function (e) {
                        console.log("e.this",e.this);
                        console.log("e.target",e.target);
                        e.target;
                    })
                }
            }
            
            cartLink.addEventListener('keydown', function (e) {
                if (e.keyCode == 13) {
                    setTimeout(() => {
                        cartfocus();
                    }, 100);
                }
            })
    
            cartLink.addEventListener('click', function (e) {
                setTimeout(() => {
                    cartfocus();
                }, 10);
            })
        }
    } catch(e){}

    try{ // #40
        const layoutSwitchers = document.querySelectorAll("layout-switcher");
        layoutSwitchers.forEach((switcher)=>{
            const buttons = switcher.querySelectorAll(".list-view__item");
            buttons.forEach((button)=>{
                if(button.className.includes("list-view__item--active")){
                    button.setAttribute("aria-label", button.getAttribute("aria-label") + " selected");
                }
                button.addEventListener("click", (event)=>{
                    clearSelected(buttons);
                    let ariaLabelText = button.getAttribute("aria-label");
                    ariaLabelText = ariaLabelText + " selected";
                    button.setAttribute("aria-label", ariaLabelText);
                })
            })
        });
        function clearSelected(buttons){
            buttons.forEach((button)=>{
                let prevAriaLabel = button.getAttribute("aria-label");
                if(prevAriaLabel.includes(" selected")){
                    prevAriaLabel = prevAriaLabel.replace(" selected", "");
                }
                button.setAttribute("aria-label", prevAriaLabel);
            });
        }
    } catch(e){}
    //
    try {
      setTimeout(() => {
        var payPalButton = document.querySelector('div.shopify-payment-button div[data-testid="PayPalInContext-button"]');  
        if (payPalButton) {
          payPalButton.setAttribute('role', 'link');
          payPalButton.setAttribute('aria-label', 'PayPal');
          payPalButton.setAttribute('aria-disabled', 'false');
          var disabledProductButton = document.querySelector('.product-form__buttons button[disabled="disabled"] + div.shopify-payment-button div[data-testid="PayPalInContext-button"]');
          if (disabledProductButton) {
              payPalButton.setAttribute('aria-disabled', 'true');
          }
          // document.querySelector('.product-form__buttons button[disabled="disabled"] + div.shopify-payment-button div[data-testid="PayPalInContext-button"]').setAttribute('aria-disabled', 'true');
        } 
      }, 5000);
    } catch (e) {}
    //
    try {
        document.querySelector('details.cart-drawer-container').addEventListener('click', function() {
          setTimeout(() => {
          const miniCartButton = document.querySelector('button.mini-cart__button');
          miniCartButton.addEventListener('click', function() {
            const miniCartContent = this.nextElementSibling;
            if (miniCartContent.hidden) {
              miniCartContent.hidden = false;
              miniCartContent.classList.add('open');
            } 
          });
          document.querySelector('button.cart-close').addEventListener('click', function() {
            const miniCartContent = this.closest('.mini-cart__content');
            miniCartContent.hidden = true;
            miniCartContent.classList.remove('open');
          });
          miniCartButton.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.click();
            }
          });
         }, 1000);
        });


    } catch (e) {}

    try {
      setTimeout(function() {
          var element = document.querySelector('div.flickity-page-dots');
          if (element) {              
              element.setAttribute('role', 'tabpanel');
          }
      }, 1000);
    } catch (e) {}
    
    try {
      var emailError = Array.from(document.querySelectorAll("p#ContactFooter-success")).filter(function(el) {
          return el.textContent.trim() === "Thanks for subscribing";
      });
      if (emailError.length > 0) {
          var successElement = document.querySelector("p#ContactFooter-success");
          if (successElement) {
              successElement.setAttribute("role", "status");
              successElement.setAttribute("aria-live", "polite");
          }
      }

    } catch (e) {}

    try {
      var button = document.querySelector(".select.shipping_btn button");
        if (button) {
            button.addEventListener('click', function() {
                setTimeout(function() {
                    var emailErrors = document.querySelectorAll(".field.form__message.errors .errors");
                    var emailError = Array.from(emailErrors).find(function(el) {
                        return el.textContent.trim() !== '';
                    });
                    
                    if (emailError) {
                        emailError.setAttribute("aria-describedby", "ShippingCalculatorZip");
                        button.focus();
                    }
                }, 2000);
            });
        }
    } catch (e) {}
    
    try {
        // #54
        function applyQuickViewFix(loopCount){
            if(loopCount < 10){
                const productGrids = document.querySelectorAll("ul.product-grid");
                if(productGrids.length > 0){
                    productGrids.forEach((productGrid, index)=>{
                        const products = productGrid.querySelectorAll("li.grid__item:not(.slider__slide)");
                        products.forEach((product, index2)=>{
                            product.querySelector(".card-information > a[href]").setAttribute("id", `product-link-${index+1}-${index2 + 1}`);
                            const quickViewButton = product.querySelector("#quick-view");
                            quickViewButton.setAttribute("id", `quick-view-${index+1}-${index2 + 1}`);
                            quickViewButton.setAttribute("aria-labelledby", `quick-view-${index+1}-${index2 + 1} product-link-${index+1}-${index2 + 1}`);
                        });
                    })
                } else {
                    setTimeout(()=>{
                        loopCount++;
                        applyQuickViewFix(loopCount);
                    }, 500);
                }
            }
        }
        let loopCount = 0;
        applyQuickViewFix(loopCount)
    } catch (e) {}

    try {
        document.addEventListener("keydown", function (event) {
    	  if (event.keyCode === 9 && event.target.matches("div.footer-block__details-content.footer-block-image a")) {
    	        event.preventDefault();
    	        var stickyCart = document.querySelector(".product-sticky-cart .sticky-cart.page-width");
    	        stickyCart.setAttribute("tabindex", "0");                
    	        stickyCart.focus();
                document.querySelector(".sticky-btn.header__icon--summary button").setAttribute("tabindex", "0");
                 document.querySelector(".product-sticky-cart .sticky-cart.page-width button").setAttribute("tabindex", "0");
    	    }
            if (event.key === "Tab" && event.target.matches(".sticky-btn.header__icon--summary button")) {
                event.preventDefault();
                var footerCopyrightButton = document.querySelector(".product-sticky-cart .sticky-cart.page-width button");
                if (footerCopyrightButton) {
                    if (event.shiftKey) {
                        footerCopyrightButton.focus();
                    } else {
                        footerCopyrightButton.focus();
                    }
                }
            }
        });
        var button = document.querySelector(".sticky-btn.header__icon--summary button");
        var stickyCartWrapper = document.querySelector(".sticky-cart-wrapper");
        function removeAnimateAttribute() {
            if (stickyCartWrapper) {
                stickyCartWrapper.removeAttribute("animate");
            }
            var footerCoptright = document.querySelector(".footer__copyright a");
              if (footerCoptright) {               
                  footerCoptright.focus();               
              }
        }
        button.addEventListener("click", removeAnimateAttribute);
        button.addEventListener("keydown", function(event) {
            if (event.key === "Enter") {
                removeAnimateAttribute();
            }
        });
    } catch (error) {}
});
